export const COOKIE_POLICY_STATUS = '__Host-opswat-cookie-policy';
export const COOKIE_POLICY_STATUS_DURATION = 30; // days
export const COOKIE_POLICY_ACCEPTED = 'accepted';
export const COOKIE_OPSWAT_REDIRECT = '__Host-opswat-redirect';
export const COOKIE_FAV_THEME = '__Host-opswat-favoriteTheme';
export const COOKIE_ANOUNCEMENT_BANNER = '__Host-announcement-banner';
export const COOKIE_ANOUNCEMENT_BANNER_CLOSE_DURATION = 14; // days;
export const COOKIE_ALREADY_USED = '__Host-opswat-already-used';
